import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelFfl as t } from "../level-metrics/index18.js";
const m = (e) => r(e, t);
export {
  m as getLevelArrayFFL
};
//# sourceMappingURL=index7.js.map
